/**
 * Query to fetch organization coordinates with additional address information
 */
const orgCoordsQuery = `
query FindOrgCoords {
  org_coords (first: 10000) {
    edges {
      node {
        objectId
        latitude
        longitude
        org_pointer {
          objectId
          nome
          stato
          tipo_istanza
          indirizzo
          citta
          cap
          nazione
        }
      }
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export default orgCoordsQuery;